import React from 'react';
import {StoreOrderInEditor} from './storeorderInEditor';
import connect from "react-redux/es/connect/connect";
import createEditor from "../../form/ComponentEditor";
import {StoreOrderEditor} from "./storeorderEditor";

export class ShopStoreOrderInEditor extends React.Component {
    render() {
        return <StoreOrderInEditor {...this.props}/>;
    }
}

export default connect((state) => {
    return {
        till: state.app.till
    }
})(createEditor({
    componentName: "storeorder",
    WrappedComponent: ShopStoreOrderInEditor,
    editor: "ShopStoreOrderIn",
    props: {
        view: "admin",
        componentActions: (action, data, params) => {
            data = {...data};
            delete data.client;
            return {action,data,params};
        }
    }
}));
